module.exports = __webpack_public_path__ + "static/media/plan-oferta-wom-150gb.c2166798.svg";